import * as React from 'react';
var DEFAULTS = {
    publish: function () { },
    subscribe: function () { },
    unsubscribe: function () { }
};
var ManagerContext = React.createContext(DEFAULTS);
export var useManager = function () { return React.useContext(ManagerContext); };
export var SignalEventsContextProvider = function (props) {
    var children = props.children, eventManager = props.eventManager;
    var manager = React.useMemo(function () {
        /*
          don't setup event subscriptions or publishing on server-side rendering since
          it's just a single render pass and we have no mechanism to perform any teardown
        */
        return (typeof window === 'undefined') ? DEFAULTS : eventManager;
    }, [eventManager]);
    return React.createElement(ManagerContext.Provider, { value: manager }, children);
};
SignalEventsContextProvider.displayName = 'EventBusProvider';
//# sourceMappingURL=provider.js.map